import React from 'react';
import { AdoptionSection, PayrollConnectionsSection } from './enrollment';
import { UserSummarySection } from '../../common/analytics';
import { applyDashboardDonutColors } from '../dashboard.constants';
import styles from './styles/enrollment-data.module.scss';

// UI copy only (titles/subtitles). All numeric values come from the API.
const COPY = {
    userAdoption: { title: 'User Adoption', subtitle: 'Opted-In, Enrolled & Active' },
    adoptionSummary: { title: 'Adoption Summary', subtitle: 'based on your total member base' },
    enrollmentFunnel: { title: 'Enrollment Funnel', subtitle: 'Users Across Each Step' },
    enrollmentSummary: { title: 'Enrollment Summary', subtitle: 'based on your total opted in base' },
    payrollHealth: { title: 'Payroll Connectivity Health', subtitle: 'Payroll Connection Breakdown', totalLabel: 'Connections' },
    payrollConnections: { title: 'Payroll Connections Summary', subtitle: 'Unique User Payroll Connections' },
    payrollLinkErrors: { title: 'Payroll Link Errors', subtitle: 'based on your total opted in base' },
};

function EnrollmentData({
    data,
    loading = false,
    userAdoptionMetrics,
    userSummary,
    funnel,
    cohort,
    onUserAdoptionFrequencyChange,
    onUserSummaryTableChange,
}) {
    const d = data || {};
    const kpis = d.kpis || [];
    const userAdoption = { ...COPY.userAdoption, ...(d.userAdoption || {}) };
    const adoptionSummary = { ...COPY.adoptionSummary, items: [], ...(d.adoptionSummary || {}) };
    // Funnel loads from its own endpoint (heavy all-time scans) so it doesn't
    // block the main enrollment payload.
    const enrollmentFunnel = {
        ...COPY.enrollmentFunnel,
        groups: [],
        steps: funnel?.steps || [],
        loading: funnel?.loading || false,
    };
    const enrollmentSummary = { ...COPY.enrollmentSummary, items: [], ...(d.enrollmentSummary || {}) };
    const payrollHealth = { ...COPY.payrollHealth, total: '0', segments: [], ...(d.payrollHealth || {}) };
    payrollHealth.segments = applyDashboardDonutColors(payrollHealth.segments, 'payrollHealth');
    const payrollConnections = { ...COPY.payrollConnections, items: [], ...(d.payrollConnections || {}) };
    const payrollLinkErrors = { ...COPY.payrollLinkErrors, items: [], ...(d.payrollLinkErrors || {}) };
    const userSummaryRows = userSummary?.rows || [];
    const userSummaryPagination = userSummary?.pageInfo || null;

    return (
        <div className={styles.enrollmentContainer}>
            <AdoptionSection
                kpis={kpis}
                userAdoption={userAdoption}
                userAdoptionMetrics={userAdoptionMetrics}
                onUserAdoptionFrequencyChange={onUserAdoptionFrequencyChange}
                adoptionSummary={adoptionSummary}
                enrollmentFunnel={enrollmentFunnel}
                enrollmentSummary={enrollmentSummary}
                cohort={cohort}
                loading={loading}
            />
            <UserSummarySection
                rows={userSummaryRows}
                loading={loading || userSummary?.loading}
                pageInfo={userSummaryPagination}
                onTableChange={onUserSummaryTableChange}
            />
            <PayrollConnectionsSection
                payrollHealth={payrollHealth}
                payrollConnections={payrollConnections}
                payrollLinkErrors={payrollLinkErrors}
                loading={loading}
            />
        </div>
    );
}

export default EnrollmentData;
